$(function() {
    "use strict";

    /**
     * Button Confirm.
     */
    $(document).on("click", ".button-confirm", function(e) {
        e.preventDefault();
        confirm($(this));
    });

    /**
     * Button Toggle.
     */
    $(document).on("click", ".button-toggle", function(e) {
        e.preventDefault();
        buttonToggle($(this));
    });

    /**
     * Chosen.
     */
    resizeChosen();
    $(window).on("resize", resizeChosen);

    /**
     * Clock.
     */
    if (typeof clock === "function") {
        clock();
    }

    /**
     * Datepicker.
     */
    datepicker();

    /**
     * Date Range Picker.
     */
    $(".daterangepicker").daterangepicker();

    /**
     * Date Time Picker.
     */
    $(".datetimepicker").datetimepicker({
        format: "d-m-Y H:i",
        theme: "dark"
    });

    /**
     * Sidebar.
     */
    initSidebar();
    $(window).on("resize", resizeSidebar);
});
